import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from '@dtvgo/icon';
import VolumeBar from '../VolumeBar/VolumeBar';
import './VolumeButton.scss';

function VolumeButton({
  handleToggleMute,
  isMuted,
  setVolume,
  volume,
}) {
  const realIsMuted = isMuted || volume === 0;
  const [isOpen, setIsOpen] = useState(false);

  let iconName;
  if (volume >= 70) iconName = 'volume-max';
  else if (volume >= 35) iconName = 'volume-middle';
  else if (volume > 0) iconName = 'volume-min';
  else iconName = 'volume-mute';

  return (
    <div
      className={`dtv-common-c-volume-wrapper ${isOpen ? 'dtv-common-c-volume-wrapper--open' : ''}`}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div className="dtv-common-c-volume-container">
        <div
          className="dtv-volume-bar-popup"
          onClick={(e) => e.stopPropagation()}
        >
          <VolumeBar setVolume={setVolume} volume={volume} isMuted={realIsMuted} />
        </div>
        <button
          type="button"
          className="dtv-common-c-volume-button-v2"
          onClick={handleToggleMute}
        >
          <Icon name={iconName} />
        </button>
      </div>
    </div>
  );
}

VolumeButton.propTypes = {
  handleToggleMute: PropTypes.func,
  isMuted: PropTypes.bool,
  setVolume: PropTypes.func,
  volume: PropTypes.number,
};

VolumeButton.defaultProps = {
  handleToggleMute() {},
  isMuted: false,
  setVolume() {},
  volume: 0,
};

export default VolumeButton;
